import { render, staticRenderFns } from "./CBadge.vue?vue&type=template&id=7d239a18&scoped=true&"
import script from "./CBadge.vue?vue&type=script&lang=js&"
export * from "./CBadge.vue?vue&type=script&lang=js&"
import style0 from "./CBadge.vue?vue&type=style&index=0&id=7d239a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d239a18",
  null
  
)

export default component.exports